import Vue from "vue";

// icons
import "./icons";

import VeLine from "v-charts/lib/line.common";
import "echarts/lib/component/markLine";

const requireComponent = require.context("./base", true, /\.vue/);
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);
  const componentName =
    "Base" + fileName.replace(/^\.\//, "").replace(/\.\w+$/, "");

  Vue.component(componentName, componentConfig.default || componentConfig);
});

// components
Vue.component(VeLine.name, VeLine);
